import "./index.scss";

/**
 * This component render Settings header
 */
interface ISettingsHeader {
    title: string;
    subtitle?: string;
    /**
     ** Reander an action to the right part of header, exemple : button
     */
    renderAction?: () => React.ReactNode;
}

const SettingsHeader = ({ title, subtitle, renderAction }: ISettingsHeader) => {
    return (
        <div className="settings-header">
            <div className="settings-header-left">
                <h1>{title}</h1>
                {subtitle && <span>{subtitle}</span>}
            </div>
            <div className="settings-header-right">{renderAction && renderAction()}</div>
        </div>
    );
};

export default SettingsHeader;
